import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SelectInput from "../Builder/nodes/Logic/Inputs/SelectInput";
import CustomReportAllSelectInput from "./CustomReportAllSelectInput";
import { useGetEventSolutionsQuery } from "../store/slices/settingsSlice";

export default function CustomReportsSolutionPickerModal({
  show,
  onHide,
  onSelect,
  config,
}) {
  const [title, setTitle] = useState("Active Events");
  const [displayMode, setDisplayMode] = useState("table");
  const [groupBy, setGroupBy] = useState("severity");
  const [statuses, setStatuses] = useState(["active"]);
  const [severities, setSeverities] = useState([]);
  const [selectedSolutionUuid, setSelectedSolutionUuid] = useState([]);
  const { data: solutions = [], isLoading } = useGetEventSolutionsQuery();
  const options = [
    { value: "", label: "Show All Events" },
    ...solutions.map((solution) => ({
      value: solution.Uuid,
      label: `${solution.SolutionName} ${solution.SolutionVersion}`,
    })),
  ];
  const selectedSolution = solutions.find(
    (solution) => solution.Uuid === selectedSolutionUuid[0]
  );
  const showingAllEvents = selectedSolutionUuid[0] === "";

  useEffect(() => {
    if (show) {
      setTitle(config?.title || "Active Events");
      setDisplayMode(config?.displayMode || "table");
      setGroupBy(config?.groupBy || "severity");
      setStatuses(config?.statuses || ["active"]);
      setSeverities(config?.severities || []);
      setSelectedSolutionUuid(config?.solutionClientUuid !== undefined ? [config.solutionClientUuid] : [""]);
    }
  }, [show, config]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select an event solution</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="active-events-title" className="form-label">Widget title</label>
          <input
            id="active-events-title"
            type="text"
            className="form-control"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            maxLength={100}
          />
        </div>
        <p className="text-secondary">
          Choose a solution, or show active events from all solutions.
        </p>
        <SelectInput
          value={selectedSolutionUuid}
          onChange={setSelectedSolutionUuid}
          options={options}
          placeholder="Select Event Solution"
          autoFocus
        />
        <div className="mt-3">
          <label className="form-label">Status</label>
          <CustomReportAllSelectInput value={statuses} onChange={setStatuses} isMulti allLabel="All statuses" options={[{ value: "creating", label: "Creating" }, { value: "active", label: "Active" }, { value: "resolved", label: "Resolved" }, { value: "closed", label: "Closed" }, { value: "archived", label: "Archived" }]} />
        </div>
        <div className="mt-3">
          <label className="form-label">Severity</label>
          <CustomReportAllSelectInput value={severities} onChange={setSeverities} isMulti allLabel="All severities" options={[{ value: "low", label: "Low" }, { value: "medium", label: "Medium" }, { value: "high", label: "High" }, { value: "critical", label: "Critical" }]} />
        </div>
        <div className="mt-3">
          <label className="form-label">Display</label>
          <SelectInput
            value={[displayMode]}
            onChange={(values) => setDisplayMode(values[0])}
            options={[
              { value: "table", label: "Table" },
              { value: "count", label: "Count" },
              { value: "pie", label: "Pie chart" },
              { value: "bar", label: "Bar graph" },
            ]}
          />
        </div>
        {displayMode !== "table" && <div className="mt-3"><label className="form-label">Group chart by</label><SelectInput value={[groupBy]} onChange={(values) => setGroupBy(values[0])} options={[{ value: "severity", label: "Severity" }, { value: "status", label: "Status" }]} /></div>}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-colored"
          disabled={(!selectedSolution && !showingAllEvents) || !title.trim() || isLoading}
          onClick={() => {
            onSelect({
              ...(selectedSolution || { Uuid: "", SolutionName: "All Solutions", SolutionVersion: "" }),
              title: title.trim(),
              displayMode,
              groupBy,
              statuses,
              severities,
            });
            onHide();
          }}
        >
          Add widget
        </button>
      </Modal.Footer>
    </Modal>
  );
}
